var ui = {
  addToCart: '[action="/cart/add"]',
  cart: '.fa-shopping-cart',
  isSample: '.is-sample',
  hasProduct: '.product-info h5',
  navToggle: document.querySelector('.navbar-toggle'),
  cartTranslated: document.querySelector('[data-cart-text]').getAttribute('data-cart-text'),
  closeTranslated: document.querySelector('[data-layout-close]').getAttribute('data-layout-close'),
  generalMenu: document.querySelector('.generalMenu').textContent
}

var hasAddToCart = isInPage(document.querySelector(ui.addToCart))
var hasProduct = isInPage(document.querySelector(ui.hasProduct))

if (hasAddToCart) {
  forEachEl(ui.addToCart, function (form) {
    form.addEventListener('submit', function (e) {
      if (!isInPage(document.querySelector(ui.isSample))) {
        e.preventDefault()
        var opts = {
          method: 'POST',
          api: '/cart/add.js',
          form: form
        }
        shopifyApi(opts, function (err, data) {
          if (err) return console.error(err)
          shopifyApi({api: '/cart.js'}, function (err, data) {
            if (err) return console.error(err)

            forEachEl(ui.cart, function (cartUI) {
              var cart = JSON.parse(data)
              var html = cartUI.outerHTML
              var cartUIContainer = html + '(' + String(cart.item_count++) + ') ' + ui.cartTranslated
              cartUI.parentNode.innerHTML = cartUIContainer
            })

            var btn = form.querySelector('.btn')
            
            //btn.setAttribute('disabled', true)
            
            setTimeout(function() {
              btn.value = "Añadiendo...";
              
              setTimeout(function() {
              	btn.value = "¡GRACIAS!";
                
                setTimeout(function() {
                  btn.value = "AÑADIR AL CARRITO";
                  document.getElementById("WC_JM_mensaje_add_carrito").innerHTML="Añadido al carrito correctamente.<br>Vea su <a href='https://bioeffectspain.es/cart'>carrito y finalize la compra</a>";
                  //btn.setAttribute('disabled', false)
                  
                }, 1000);
                
              }, 1000);
              
            }, 1000);
            
            
            
            //btn.value = btn.getAttribute('data-added')
            //btn.className += ' btn-disabled'

            //btn.setAttribute('disabled', true)


            /* fb pixel */
            if(typeof fbq !== 'undefined') {
              fbq('track', 'AddToCart');

            }
          })
        })
      }
    })
  })
}




if (hasProduct) {
  var product = document.querySelector(ui.hasProduct)
  var isFreeSample = product.textContent.indexOf('Sample') > -1

  if (isFreeSample) {
    document.querySelector('.cart-sample-cta').innerHTML = ''
  }
}

var toggled = false
var toggleSpan = ui.navToggle.querySelector('span')
ui.navToggle.addEventListener('click', function () {
  if (!toggled) {
    toggleSpan.textContent = ui.closeTranslated + ' [x]'
  } else {
    toggleSpan.textContent = ui.generalMenu
  }

  toggled = !toggled
})

function MobileNav (element, options) {
  if (!element) {
    return
  }

  this.element = element
  this.closeBtn = options.closeBtn
  this.topLevelListItem = options.topLevelListItem
  this.topLevelLink = options.topLevelLink
  this.dropdown = options.dropdown
}

MobileNav.prototype.init = function () {
  if (!this.element) {
    return
  }
  this.attachEvents()
}

MobileNav.prototype.attachEvents = function () {
  var self = this

  // $(this.closeBtn).on('click', () => {
  //   $(this.element).removeClass('isActive')
  //   $('body').css({ overflow: '' })
  // })

  $(this.topLevelLink).on('click', function (e) {
    var dropdown = $(this).parents(self.topLevelListItem).find(self.dropdown)
    if (dropdown.length) {
      $(this).toggleClass('isActive')
      $(this).parents(self.topLevelListItem).find(self.dropdown).slideToggle('fast')
      return false
    }
  })
}

var mobileNav = new MobileNav('.mobileNav', {
  closeBtn: '.mobileNav__closeBtn',
  topLevelListItem: '.mobileNav__listItem',
  topLevelLink: '.mobileNav__link span',
  dropdown: '.mobileNav__dropdown'
})

mobileNav.init()

function shopifyApi (opts, cb) {
  if (!opts) opts = {}
  var xhr = new XMLHttpRequest()

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) cb(null, xhr.responseText)
      else cb('We reached our target server, but it returned an error')
    }
  }

  xhr.open(opts.method || 'GET', opts.api)

  var data = opts.method === 'POST'
    ? new FormData(opts.form)
    : null

  xhr.send(data)
}

function forEachEl (el, cb) {
  [].forEach.call(document.querySelectorAll(el), cb)
}

function isInPage (node) {
  return (node === document.body) ? false : document.body.contains(node)
}
